export class Search {
  constructor() {
    this.init();
  }

  searchBackground() {
    let dropdown = $('.header-menu--search--content');
    let offsetHeight = dropdown.outerHeight();
    $('.header-menu--search--background').css({
      transform: 'scaleY(' + offsetHeight + ')',
    });
  }

  init() {
    var self = this;

    let $searchContent = $('.header-menu--search--content');
    $searchContent.addClass('inactive');
    $(once('header-search-toggle', '.header-menu--search--toggle')).on(
      'click',
      function () {
        var $search = $(this).parent();
        if ($search.hasClass('open')) {
          $search.removeClass('open');
          $searchContent.one('transitionend', function () {
            $searchContent.addClass('inactive');
          });
          $('.header-menu--search--background').removeClass('active');
          return;
        } else {
          let openId = $('.header-menu--main-menu .level-1.open').attr(
            'data-dropdown-id'
          );
          $('.level-1[data-dropdown-id="' + openId + '"] .has-children').attr(
            'aria-expanded',
            false
          );
          var $currentNav = $(
            '.level-1[data-dropdown-id="' + openId + '"]'
          ).removeClass('open');
          $currentNav.one('transitionend', function (e) {
            $currentNav.addClass('inactive');
          });
          $('.header-menu--indicator, .header-menu--background').removeClass(
            'active'
          );
        }
        self.searchBackground();
        $searchContent.removeClass('inactive');
        const $alert = $('.alert.sticky');
        const alertHeight = $alert.length ? $alert.outerHeight() : 0;
        const headerHeight = $('.rush-system-header').outerHeight();
        $searchContent[0].style.setProperty(
          '--header-height',
          alertHeight + headerHeight + 'px'
        );
        $search.addClass('open');
        $('.header-menu--search--background').addClass('active');
        // Close main menu if open.
        const $openMobileHeader = $('.header-menu--mobile.open');
        if ($openMobileHeader.length) {
          $openMobileHeader.removeClass('open');
          const $mobileDropdown = $('.header-menu--mobile--dropdown');
          $('body').css({ overflow: 'hidden' });
          $mobileDropdown.one('transitionend', function () {
            $mobileDropdown.removeClass('inactive');
          });
        }
      }
    );

    $('.main, .header-menu--search--close').on('click', function () {
      var $search = $('.header-menu--search').removeClass('open');
      $searchContent.one('transitionend', function (e) {
        $searchContent.addClass('inactive');
      });
      $('.header-menu--search--background').removeClass('active');
    });

    let tabNavGlobal = $('.header-menu__tabs--nav-global');
    let tabNavDoctor = $('.header-menu__tabs--nav-doctor');
    let tabContentGlobal = $('.header-menu__tabs--global');
    let tabContentDoctor = $('.header-menu__tabs--doctor');

    tabNavGlobal.addClass('active');
    tabContentGlobal.show();
    tabContentDoctor.hide();

    tabNavGlobal.on('click', function () {
      tabContentGlobal.show();
      tabContentDoctor.hide();
      tabNavDoctor.removeClass('active');
      $(this).addClass('active');
      self.searchBackground();
    });

    tabNavDoctor.on('click', function () {
      tabContentDoctor.show();
      tabContentGlobal.hide();
      tabNavGlobal.removeClass('active');
      $(this).addClass('active');
      self.searchBackground();
    });
  }
}
